/**
 * @generated SignedSource<<2c9d68490923437ea60cf756293843ca>>
 * @relayHash 91a71e58987a809e8fab56a5b20653ee
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d360f89451db996d39d7d8afdaa4458a187a7214d2fcfc4d683dfe1fe8e77d54

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d360f89451db996d39d7d8afdaa4458a187a7214d2fcfc4d683dfe1fe8e77d54",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
